import request from '@/utils/request'

// 获取eSIM列表
export function cardEsimPage(data) {
  return request({
    url: '/cardEsim/page',
    method: 'post',
    data: data
  })
}


// 获取二维码
export function eSIMQrCode(data) {
  return request({
    url: '/cardEsim/qrcode',
    method: 'get',
    params: data
  })
}

// 刷新eSIM信息
export function eSIMRefresh(data) {
  return request({
    url: '/cardEsim/refresh',
    method: 'get',
    params: data
  })
}

// 导出eSIM图片
export function exportEsim(data){
  return request({
    url: '/cardEsim/exportCard',
    method: 'post',
    data: data
  })
}









